import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import React, { useEffect, useState } from 'react'
import useFetchData from '../../../../../hooks/useFetchData'
import Skeleton from '@mui/material/Skeleton'
import Alert from '@mui/material/Alert'
import { Checkbox, FormControlLabel } from '@mui/material'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import { useSnackbar } from 'notistack'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateCurriculum } from '../../../../../services/tenant/tenant.service'
import { handlerErrorV2 } from '../../../../../utils/errors'

const Curriculum = ({ permission, curriculumId = [] }) => {
  const { isLoading, data } = useFetchData('curriculum')
  const { enqueueSnackbar } = useSnackbar()
  const [form, setInputForm] = useState({ curriculumId })
  const [error, setInputErrors] = useState({})
  const [loading, toggleLoading] = useState(false)

  useEffect(() => {
    setInputForm({ curriculumId })
  }, [curriculumId])

  const onSave = async (e) => {
    e.preventDefault()
    setInputErrors({})

    try {
      toggleLoading(true)
      const result = await updateCurriculum(form)
      if (!result.data && result.error) {
        setInputErrors({
          message: result.error.message || 'Something went wrong. Please try again.'
        })
      } else {
        enqueueSnackbar('Updated successfully', { variant: 'success' })
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setInputErrors({ message })
    } finally {
      toggleLoading(false)
    }
  }

  const handleChange = (event) => {
    const { checked, value } = event.target
    let data = new Set(form.curriculumId)
    if (checked) {
      data.add(value)
    } else {
      data.delete(value)
    }
    setInputForm({ ...form, curriculumId: Array.from(data) })
  }

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Curriculum
        </Typography>
        {!isLoading && permission && (
          <ButtonStartIcon
            onClick={onSave}
            color='secondary'
            loading={loading}
            variant='contained'
            startIcon={['fal', 'check']}
          >
            Save
          </ButtonStartIcon>
        )}
      </Box>
      <Box className='px-2 py-2'>
        <Grid container spacing={1}>
          {isLoading
            ? Array(2)
                .fill()
                .map((_, i) => (
                  <Grid item md={3} sm={6} key={i} className='h-16'>
                    <Skeleton height={'100%'} />
                  </Grid>
                ))
            : data?.map((item) => (
                <Grid item md={4} sm={6} key={item._id}>
                  <Paper className='overflow-hidden'>
                    <div className='px-4 py-2'>
                      {permission ? (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={form?.curriculumId.includes(item._id)}
                              onChange={item.isDefault ? () => {} : handleChange}
                              name={item._id}
                              value={item._id}
                              disabled={loading}
                              color='primary'
                            />
                          }
                          label={
                            <Typography variant='inherit' color='primary'>
                              {item.name}
                            </Typography>
                          }
                        />
                      ) : (
                        <div className='flex items-center gap-2 py-4'>
                          <FontAwesomeIcon
                            icon={
                              form?.curriculumId.includes(item._id)
                                ? ['fas', 'square-check']
                                : ['far', 'square']
                            }
                            className='text-primary text-xl'
                          />
                          <Typography variant='inherit' color='primary'>
                            {item.name}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Paper>
                </Grid>
              ))}
          {error.message && (
            <Grid item md={12}>
              <Alert severity='error'>{error.message}</Alert>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  )
}

export default Curriculum
